import { FormikTextField } from '@cmg/design-system-formik';

import { FormFieldLayout } from '../../../../../../design-system/body-sections/form/FormFieldLayout';
import { FormLayout } from '../../../../../../design-system/body-sections/form/FormLayout';
import { USER_DETAIL_FIELD_LABELS } from '../models/UserDetailsSection.model';

export function EmployeeContactInformationFields() {
  return (
    <FormLayout>
      <FormFieldLayout>
        <FormikTextField name="address1" label={USER_DETAIL_FIELD_LABELS.address1} fullWidth />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField name="address2" label={USER_DETAIL_FIELD_LABELS.address2} fullWidth />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField name="email1" label={USER_DETAIL_FIELD_LABELS.email1} fullWidth />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField name="email2" label={USER_DETAIL_FIELD_LABELS.email2} fullWidth />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField
          name="phoneNumber1"
          label={USER_DETAIL_FIELD_LABELS.phoneNumber1}
          fullWidth
        />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField
          name="phoneNumber2"
          label={USER_DETAIL_FIELD_LABELS.phoneNumber2}
          fullWidth
        />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField name="faxNumber1" label={USER_DETAIL_FIELD_LABELS.faxNumber1} fullWidth />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField name="faxNumber2" label={USER_DETAIL_FIELD_LABELS.faxNumber2} fullWidth />
      </FormFieldLayout>
    </FormLayout>
  );
}
